module.exports = __webpack_public_path__ + "img/STAR SHADES PURPLE.ebd20b5.svg";